/** @jsxImportSource @emotion/react */
import React from "react";
import { useSearchParams } from "react-router-dom";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { SignalsPage } from "./SignalsPage";

interface SignalInboxModalProps {
    isOpen: boolean;
}

const SignalInboxModal: React.FC<SignalInboxModalProps> = ({
    isOpen,
}) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const handleClose = () => {
        searchParams.delete("signals");
        setSearchParams(searchParams);
    };

    return (
        <>
            <Modal isOpen={isOpen} toggle={handleClose} size="lg" >
                <ModalHeader toggle={handleClose}>
                    Signals
                </ModalHeader>

                <ModalBody>
                    <SignalsPage isInModal />
                </ModalBody>
            </Modal>
        </>
    );
};

export default SignalInboxModal;
